module.exports = "/assets/data/1c7dda1f51cb7ce66b4f5734694aa84e-SE27.data.json";